webpackJsonp([3],{

/***/ 187:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__(175);
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__(174);
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__(172);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__(119);
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__(120);
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__(173);
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// CONCATENATED MODULE: ./src/services/Api/fetchival/index.js


var responseTypes = ["json", "text", "response"];

var fetchival__fetch = function _fetch(method, url) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var queryParams = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

  var newOpts = extends_default()({}, opts, {
    method: method,
    headers: extends_default()({
      Accept: "application/json",
      "Content-Type": "application/json"
    }, opts.headers),
    responseAs: responseTypes[Math.max(0, responseTypes.indexOf(opts.responseAs))]
  });

  if (data !== null) {
    newOpts.body = stringify_default()(data);
  }

  return fetchival_fetchival.fetch(url, newOpts).then(function (response) {
    if (response.status >= 200 && response.status < 300) {
      if (newOpts.responseAs === "response") {
        return response;
      } else if (response.status === 204) {
        return null;
      } else {
        return response[newOpts.responseAs]();
      }
    } else {
      var err = new Error(response.statusText);
      err.response = response;
      console.error(err);
      throw err;
    }
  });
};

var fetchival_fetchival = function fetchival(url) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _ = function _(u) {
    var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return fetchival(url + "/" + u, extends_default()({}, opts, o));
  };

  _.get = function (queryParams) {
    return fetchival__fetch("GET", url, opts, null, queryParams);
  };
  _.post = function (data) {
    return fetchival__fetch("POST", url, opts, data);
  };
  _.put = function (data) {
    return fetchival__fetch("PUT", url, opts, data);
  };
  _.patch = function (data) {
    return fetchival__fetch("PATCH", url, opts, data);
  };
  _.delete = function () {
    return fetchival__fetch("DELETE", url, opts);
  };
  _.head = function () {
    return fetchival__fetch("HEAD", url, extends_default()({}, opts, { responseAs: 'text' }));
  };

  return _;
};

fetchival_fetchival.fetch = typeof fetch !== "undefined" ? fetch.bind(window) : null;

/* harmony default export */ var Api_fetchival = (fetchival_fetchival);
// CONCATENATED MODULE: ./src/services/Api/api.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Resolvers; });
/* unused harmony export addTransforms */
/* unused harmony export resolveSchema */








var createCacheObject = function createCacheObject(value) {
  return {
    date: new Date(),
    value: value
  };
};

var api_applyPostTransforms = function applyPostTransforms(schema) {
  return function (result) {
    var newResult = promise_default.a.resolve(result);

    if (schema.transforms && schema.transforms.post) {
      newResult = schema.transforms.post.reduce(function (acc, transformer) {
        return acc.then(function (data) {
          return transformer(data, schema);
        });
      }, newResult);
    }

    return newResult;
  };
};

var cachers = {};

var api_CACHED_FETCH = function CACHED_FETCH(name) {
  if (!cachers[name]) {
    var cache = {};
    var requestCache = {};
    cachers[name] = function (cachingTime) {
      return function (schema) {
        var key = stringify_default()(schema.cachingKeys || schema.endpoint);

        if (cache[key] && (cachingTime === 0 || new Date().getTime() - cache[key].date.getTime() < cachingTime)) {
          return promise_default.a.resolve(cache[key].value);
        } else {
          if (requestCache[key]) return requestCache[key];

          var call = api_FETCH(schema).then(function (result) {
            cache = extends_default()({}, cache, defineProperty_default()({}, key, createCacheObject(result)));

            delete requestCache[key];

            return result;
          });

          requestCache[key] = call;
          return call;
        }
      };
    };
  }
  return cachers[name];
};

var api_STUBBED = function STUBBED(schema) {
  return promise_default.a.resolve(schema.stubData).then(api_applyPostTransforms(schema));
};

var api_FETCH = function FETCH(schema) {
  var methods = Api_fetchival(schema.endpoint, {
    headers: schema.headers,
    responseAs: schema.as
  });

  return methods[schema.method.toLowerCase()](keys_default()(schema.payload).length > 0 ? schema.payload : null).then(api_applyPostTransforms(schema));
};

var api_XHR = function XHR(schema) {
  var req = new XMLHttpRequest();
  req.open(schema.method, schema.endpoint, true);

  keys_default()(schema.headers).forEach(function (key) {
    req.setRequestHeader(key, schema.headers[key]);
  });

  return {
    request: req,
    transformer: api_applyPostTransforms(schema),
    payload: schema.payload
  };
};

var Resolvers = {
  CACHED_FETCH: api_CACHED_FETCH,
  FETCH: api_FETCH,
  XHR: api_XHR,
  STUBBED: api_STUBBED
};

var defaults = {
  endpoint: "",
  method: "GET",
  payload: {},
  parameters: {},
  headers: {},
  resolver: api_FETCH,
  as: "json"
};

var api_addTransforms = function addTransforms(schema, transforms) {
  return extends_default()({}, schema, {
    transforms: {
      pre: [].concat(toConsumableArray_default()(schema.transforms ? schema.transforms.pre : []), toConsumableArray_default()(transforms.pre)),
      post: [].concat(toConsumableArray_default()(schema.transforms ? schema.transforms.post : []), toConsumableArray_default()(transforms.post))
    }
  });
};

var api_resolveSchema = function resolveSchema(schema) {
  var newSchema = extends_default()({}, defaults, schema);

  if (schema.transforms && schema.transforms.pre) {
    newSchema = schema.transforms.pre.reduce(function (acc, transformer) {
      return transformer(acc);
    }, newSchema);
  }

  var paramNames = keys_default()(newSchema.parameters);

  var newEndpoint = paramNames.reduce(function (acc, key) {
    return acc.replace("{" + key + "}", newSchema.parameters[key]);
  }, newSchema.endpoint);

  var finalSchema = extends_default()({}, newSchema, {
    endpoint: newEndpoint
  });

  return finalSchema.resolver(finalSchema);
};

/* harmony default export */ var api = __webpack_exports__["b"] = (api_resolveSchema);

/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(198);
__webpack_require__(203);
module.exports = __webpack_require__(405);


/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {



if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(199).enable();
  window.Promise = __webpack_require__(201);
}

// fetch() polyfill for making API calls.
__webpack_require__(202);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(179);


/***/ }),

/***/ 405:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/services/Api/api.js + 1 modules
var api = __webpack_require__(187);

// CONCATENATED MODULE: ./src/services/Api/local.js


/* harmony default export */ var local = (api["b" /* default */]);

var getJson = function getJson(path) {
  return {
    method: "GET",
    endpoint: "" + "" + path
  };
};
// CONCATENATED MODULE: ./src/index.js


local(getJson("/config/app.json")).then(function (config) {
  window.__appConfig__ = config;
  __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1030)).then(function () {});
});

/***/ })

},[197]);


// WEBPACK FOOTER //
// static/js/main.b2e663a0.js